import React, { Component, Fragment } from 'react';
import { Carousel } from 'antd';
import { Link } from 'react-router-dom';

export class GettingStartedView extends Component {
    render() {
        return (
            <Fragment>
                <div className={'image-card getting-started-image-card'}>
                    <h1>Getting Started</h1>

                    <h2>
                        Thank you for signing up to Apex. <br />
                        Follow the steps below to get started.
                    </h2>
                </div>

                <Carousel autoplay>
                    <div className="hero">
                        <div className={'wrapper'}>
                            <h1 className="hero-title">Login to your Exchange</h1>
                            <p className="hero-lead">
                                To start trading you're going to need an exchange account. Apex
                                currently supports Binance and Kucoin. If you are yet to have an
                                account you can create one here
                            </p>
                            <a
                                className={'ant-btn btn-cta ant-btn-primary'}
                                target="_blank"
                                href="https://www.binance.com/?ref=28202153"
                                rel="noopener noreferrer"
                            >
                                Create a Binance Account
                            </a>
                            &nbsp;&nbsp;
                            <a
                                className={'ant-btn btn-cta ant-btn-primary'}
                                target="_blank"
                                href="https://www.kucoin.com/?rcode=sJyK26"
                                rel="noopener noreferrer"
                            >
                                Create a Kucoin Account
                            </a>
                            &nbsp;&nbsp;
                            <a
                                className={'ant-btn btn-cta ant-btn-primary'}
                                target="_blank"
                                href="https://www.kraken.com/sign-up"
                                rel="noopener noreferrer"
                            >
                                Create a Kraken Account
                            </a>
                        </div>
                    </div>

                    <div className="hero">
                        <div className={'wrapper'}>
                            <h1 className="hero-title">Api Keys</h1>
                            <p className="hero-lead">
                                Apex connects to your Exchange account with the use of API keys. If
                                you unsure on how to setup API keys for your account you can follow
                                these steps{' '}
                            </p>
                            <a
                                className={'ant-btn btn-cta ant-btn-primary'}
                                target="_blank"
                                href="https://support.binance.com/hc/en-us/articles/360002502072-How-to-create-API"
                                rel="noopener noreferrer"
                            >
                                Binance
                            </a>
                            &nbsp;&nbsp;
                            <a
                                className={'ant-btn btn-cta ant-btn-primary'}
                                target="_blank"
                                href="https://kucoin.zendesk.com/hc/en-us/articles/360015102174-How-to-Create-an-API"
                                rel="noopener noreferrer"
                            >
                                Kucoin
                            </a>
                            &nbsp;&nbsp;
                            <a
                                className={'ant-btn btn-cta ant-btn-primary'}
                                target="_blank"
                                href="https://support.kraken.com/hc/en-us/articles/360000919966-How-to-generate-an-API-key-pair-"
                                rel="noopener noreferrer"
                            >
                                Kucoin
                            </a>
                        </div>
                    </div>

                    <div className="hero">
                        <div className={'wrapper'}>
                            <h1 className="hero-title">Get a Strategy</h1>
                            <p className="hero-lead">
                                If you are an advanced trader we have a range of technical
                                indicators available for manual setup via the strategy tab. For the
                                newer traders we have a number of community built strategies
                                available for use, these can be found in the Strat Center
                            </p>
                            <Link
                                style={{ marginRight: 15 }}
                                className={'ant-btn btn-cta ant-btn-primary'}
                                to="/a/strat-center/"
                            >
                                Go to Strategy Center
                            </Link>
                            <Link className={'ant-btn btn-cta ant-btn-primary'} to="/a/strategies/">
                                Create a Strategy
                            </Link>
                        </div>
                    </div>

                    <div className="hero">
                        <div className={'wrapper'}>
                            <h1 className="hero-title">Create your Bot Profile</h1>
                            <p className="hero-lead">
                                The next step is the creation of the bot profile. Fill out the form
                                with basic details like name, strategy to run and api keys. Remember
                                to head to the settings tab to complete the final details after your
                                bot has been built.
                            </p>
                            <Link className={'ant-btn btn-cta ant-btn-primary'} to="/a/bots/new">
                                Create a Bot
                            </Link>
                        </div>
                    </div>

                    <div className="hero">
                        <div className={'wrapper'}>
                            <h1 className="hero-title">Assign a Subscription</h1>
                            <p className="hero-lead">
                                The final step is to assign the bot profile to a subscription, press
                                the "New Subscription" button to be taken to a selection of options
                                if this is a new account choose Free Trial. Once you subscription is
                                setup you will see it in the subscriptions table, under attached to
                                bot column click the menu and choose the profile you created in the
                                previous step. Apex will then create you your own VPS, this may take
                                a minute or two as the resources are assigned to you. You should now
                                be up and running
                            </p>
                            <Link
                                className={'ant-btn btn-cta ant-btn-primary'}
                                to="/a/subscriptions"
                            >
                                Create a Bot
                            </Link>
                        </div>
                    </div>
                </Carousel>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/GettingStarted/index.js